import anschuetz from './anschuetz.svg';
import logoWithText from './logoWithText.svg';
import raytheonLogo from './raytheonLogo.svg';

export default {
  logoWithText,
  raytheonLogo,
  anschuetz,
};
